import { useEffect, useState, useRef } from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import img105 from "../assests/QIMG4.jpeg";
import capture2 from "../assests/img7.jpeg";
import race1 from "../assests/race1.png";
import img1 from "../assests/IMG_6790.jpeg";
import img2 from "../assests/pdg2.jpg";
import img3 from "../assests/pdg4.jpg";
import img4 from "../assests/csi1.jpg";
import img5 from "../assests/csi2.jpg";
import img6 from "../assests/qac11.jpg";
import EmblaHome from "./EmblaHome";
import vid1 from "../assests/vid2.mp4";

const Home = () => {
  const videoRef = useRef();
  const [playbackRate, setPlaybackRate] = useState(0.5);

  useEffect(() => {
    videoRef.current.playbackRate = playbackRate;
  }, [playbackRate]);

  const setPlayBack = (e) => {
    setPlaybackRate(e.target.value);
  };

  return (
    <div
      name="Home"
      className=" grid grid-cols-1 col-span-1 h-full w-full relative group"
    >
      {/* welcome image */}
      {/* gradient code bg-gradient-to-tr from-blue-300 to-red-500 */}
      <div className=" flex bg-gradient-to-tr from-blue-800 to-blue-800 md:pt-6 w-full grid-cols-1  relative h-[600px]  md:h-[1200px]">
        {/*  Home image*/}

        {/* <div className="w-full pt-20 object-contain absolute mix-blend-overlay brightness-50 ">
          {<EmblaHome />}
        </div> */}

        {
          <video
            playsInline
            className="w-full  h-full object-cover absolute mix-blend-overlay  "
            ref={videoRef}
            muted
            autostart
            autoPlay
            loop
            //playsinline
            //test for iphone
            //enableInlineVideo
          >
            <source src={vid1} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          //   <form>
          //   <input onInput={setPlayBack} type="range" value={playbackRate} min="0.5" max="4" step="0.1" />
          // </form>

          /* <video
          className="w-full h-full object-cover  absolute mix-blend-overlay brightness-50 "
          controls
          autostart
          autoPlay
          src={vid1}
          type="video/mp4"
          muted
        /> */
        }
        {/* <img
          src={img1}
          className="w-full h-[600px] pt-36 object-cover absolute mix-blend-overlay brightness-50 "
          alt="Welcome Image"
          loading="lazy"
        /> */}
        <div className=" grid grid-cols-1  w-full h-full  text-center  items-center justify-center font-bold">
          <div className="  text-center md:pt-0 pt-10 text-3xl md:text-6xl text-white font-bold ">
            Welcome to Qhubeka Athletic Club
            <div className=" text-white py-4 text-xl text-center md:text-4xl font-bold ">
              #LevelUp
            </div>
          </div>
        </div>
      </div>

      {/* <div className=" shadow-[#0f0f0f] bg-[#001ea1] w-full justify-center items-center relative">
        <a href="https://secure.onreg.com/onreg2/front/step1.php?id=6877">
          <img
            src={race1}
            className=" shadow-lg shadow-[#0f0f0f]  w-full object-contain "
            alt="Welcome Image"
            loading="lazy"
          />
        </a>
      </div> */}

      {/* <div className="  items-center flex justify-center object-center ">
        <a href="https://secure.onreg.com/onreg2/front/step1.php?id=6877">
          <button className="bg-[#001ea1] text-white text-sm md:text-xl  font-bold shadow-2xl shadow-black rounded-lg  z-10 my-6 flex py-3 px-6 items-center hover:scale-110 duration-500">
            To Enter Click Here <HiArrowNarrowRight className="ml-3" />
          </button>
        </a>
      </div> */}
      <div className="   text-2xl md:text-4xl md:py-5 shadow-2xl shadow-white bg-white items-center  justify-center text-center font-bold first-letter text-[#001ea1] tracking-wider">
        What Qhubeka Means
      </div>
      <div className=" px-5 bg-white gap-5 ">
        {/** Grid Item */}

        <div className=" grid md:grid-cols-3 gap-5  ">
          {/** Grid Item */}
          <div className=" bg-[#001ea1] shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto ">
            {/**Hover effect */}
            <div className="">
              <span className=" py-3 text-base  items-center flex justify-center text-center font-bold first-letter text-white tracking-wider">
                The name Qhubeka is more than just a word – it’s a philosophy
                that drives everything we do. In isiXhosa and isiZulu, Qhubeka
                means "to move forward" or "to progress." This embodies our
                club's commitment to growth, resilience, and determination, both
                in running and in life
              </span>
            </div>
          </div>
          <div className=" shadow-[#0f0f0f] container rounded-xl flex justify-center items-center  ">
            <img
              src={capture2}
              className=" hover:scale-110 duration-1000 shadow-lg shadow-[#0f0f0f] object-cover w-full  rounded-md  object-center  md:h-[400px]"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" bg-red-700 shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto">
            {/**Hover effect */}
            <div className="">
              <div>
                <span className="px-4 text-base py-3 text-white text-center items-center flex justify-center font-bold first-letter tracking-wider">
                  At Qhubeka AC, every stride is a step toward progress. Whether
                  it’s reaching a new PB, conquering a challenging hill, or
                  simply showing up for the journey, we believe in the power of
                  moving forward.
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className=" grid md:grid-cols-3 bg-white gap-5 pt-7 py-5 ">
          {/** Grid Item */}
          <div className=" bg-[#001ea1] shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto ">
            {/**Hover effect */}
            <div className="">
              <span className=" py-3 text-base  items-center flex justify-center text-center font-bold first-letter text-white tracking-wider">
                This spirit of progress resonates far and wide, especially on
                race day. As we run, spectators and fellow runners cheer us on
                with shouts of “Qhubeka!”—a rallying cry that motivates and
                reminds us to keep pushing, no matter the challenge
              </span>
            </div>
          </div>
          <div className=" shadow-[#0f0f0f] container rounded-xl flex justify-center items-center  ">
            <img
              src={img105}
              className="hover:scale-110 duration-1000 shadow-lg shadow-[#0f0f0f] object-cover w-full  rounded-md  object-center  md:h-[400px]"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" bg-red-700 shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto">
            {/**Hover effect */}
            <div className="">
              <div>
                <span className="px-4 text-base py-3 text-white text-center items-center flex justify-center font-bold first-letter tracking-wider">
                  Beyond the track, we embody the Qhubeka ethos through
                  charitable initiatives, fostering community, and uplifting one
                  another. Together, we celebrate every milestone, knowing that
                  with unity and perseverance, we can overcome any challenge.
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="">
              <span className="px-5 pt-5 text-base text-[#001ea1] items-center flex justify-center text-center font-bold first-letter text-[#001ea1]tracking-wider">
                The name Qhubeka is more than just a word – it’s a philosophy
                that drives everything we do. In isiXhosa and isiZulu, Qhubeka
                means "to move forward" or "to progress." This embodies our
                club's commitment to growth, resilience, and determination, both
                in running and in life
              </span>
            </div> */}
      </div>
      <div className=" px-5 grid md:grid-cols-3 bg-white gap-5  md:py-5 ">
        {/** Grid Item */}
        <div className=" bg-[#001ea1] shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto ">
          {/**Hover effect */}
          <div className=" shadow-[#0f0f0f] container rounded-xl flex justify-center items-center  ">
            <img
              src={img1}
              className="hover:scale-110 duration-1000 shadow-lg shadow-[#0f0f0f] object-cover w-full  rounded-md  object-center  md:h-[400px]"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
        </div>

        <div className=" bg-red-700 shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto">
          {/**Hover effect */}
          <div className="">
            <div>
              <span className="px-4 text-base  py-3 text-white text-center items-center flex justify-center font-bold first-letter tracking-wider">
                Qhubeka is more than just a name – it’s a call to action: Keep
                moving. Keep growing. Keep leveling up.
              </span>
            </div>
          </div>
        </div>
        <div className=" shadow-[#0f0f0f] container rounded-xl flex justify-center items-center  ">
          <img
            src={img6}
            className="hover:scale-110 duration-1000 shadow-lg shadow-[#0f0f0f] object-cover w-full  rounded-md  object-center  md:h-[400px]"
            alt="Welcome Image"
            loading="lazy"
          />
        </div>
      </div>
      {/* <div className='w-full object-fit background-size:contain justify-center object-center container  '>

      {<ComradesShoot/>}
      </div> */}
      <div className="  px-5 text-2xl md:text-4xl md:py-5 shadow-2xl shadow-white bg-white items-center  justify-center text-center font-bold first-letter text-[#001ea1] tracking-wider">
        Our Commitment to Community: CSI Initiatives
        <p className="items-center text-base font-normal py-2 rounded-md justify-center   ">
          At Qhubeka AC, we believe that progress isn’t just about crossing the
          finish line—it’s about uplifting the community around us.
        </p>
        <p className="items-center text-base rounded-md font-normal  justify-center   ">
          As we level up in our training and races, we also strive to level up
          our community. Our dedication to giving back is at the core of who we
          are, supporting initiatives that make a tangible difference in the
          lives of those in need
        </p>
        <p className="items-center py-2 font-bold text-base rounded-md justify-center   ">
          Pad A Girl Campaign
        </p>
      </div>
      <div className=" grid md:grid-cols-3 bg-white gap-5 md:pb-4  px-5">
        {/** Grid Item */}
        <div className=" bg-[#001ea1] shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto ">
          {/**Hover effect */}
          <div className=" shadow-[#0f0f0f] container rounded-xl flex justify-center items-center  ">
            <img
              src={img2}
              className="hover:scale-110 duration-1000 shadow-lg shadow-[#0f0f0f] object-cover w-full  rounded-md  object-center  md:h-[400px]"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
        </div>

        <div className=" bg-red-700 shadow-lg shadow-[#0f0f0f] group container rounded-md  justify-center items-center mx-auto">
          {/**Hover effect */}
          <div className="py-3">
            <span className="md:pt-16 flex text-xl text-white text-center items-center justify-center font-bold ">
              <em>The Pad A Girl Campaign </em>
            </span>
            <div className=" flex text-base text-white text-center items-center justify-center font-bold ">
              is a cause close to our hearts, and we are proud to participate in
              this initiative annually. Each year, during the
            </div>
            <div className="flex text-base text-white text-center items-center justify-center font-bold ">
              <em>Pad A Girl Women’s Day Charity Fun Run</em>,
            </div>
            <div className="flex text-base text-white text-center items-center justify-center font-bold ">
              our members come together to donate sanitary products and raise
              awareness for this important cause. This campaign ensures that
              girls in need can attend school with confidence and dignity,
              embodying the true spirit of compassion and community
            </div>
          </div>
        </div>
        <div className=" shadow-[#0f0f0f] container rounded-xl flex justify-center items-center  ">
          <img
            src={img3}
            className="hover:scale-110 duration-1000 shadow-lg shadow-[#0f0f0f] object-cover w-full  rounded-md  object-center  md:h-[400px]"
            alt="Welcome Image"
            loading="lazy"
          />
        </div>
      </div>
      <div className="  px-5 text-2xl md:text-4xl md:py-5 shadow-2xl shadow-white bg-white items-center  justify-center text-center font-bold first-letter text-[#001ea1] tracking-wider">
        <p className="items-center text-xl font-bold rounded-md justify-center   ">
          Support for Vulnerable Children
        </p>
      </div>
      <div className=" grid md:grid-cols-3 bg-white gap-5 py-1 px-5">
        {/** Grid Item */}
        <div className=" bg-[#001ea1] shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto ">
          {/**Hover effect */}
          <div className=" shadow-[#0f0f0f] container rounded-xl flex justify-center items-center  ">
            <img
              src={img4}
              className="hover:scale-110 duration-1000 shadow-lg shadow-[#0f0f0f] object-cover w-full  rounded-md  object-center  md:h-[400px]"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
        </div>

        <div className=" bg-red-700 shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto">
          {/**Hover effect */}
          <div className="items-center py-3 justify-center ">
            <div>
              <span className=" flex  text-base pt-5 text-white text-center items-center  justify-center font-bold ">
                We also believe in leveling up the future for children who need
                it most. By supporting organizations like the
              </span>
              <span className="  text-base text-white text-center items-center justify-center font-bold">
                <em> </em>
              </span>
              <span className=" text-base text-white text-center items-center justify-center font-bold"></span>
              <span className=" flex text-base text-white text-center items-center justify-center font-bold">
                <em>
                  Windmill Park Multipurpose and Centre The Salvation Army Carl
                  Sithole Children’s Home,
                </em>
              </span>

              <span className="flex text-base text-white text-center items-center justify-center font-bold">
                donating funds and essential resources to provide shelter,
                education, and care for children who have suffered abuse,
                neglect, or abandonment. These efforts reflect our belief in
                creating a brighter future for the next generation.
              </span>
            </div>
          </div>
        </div>
        <div className=" shadow-[#0f0f0f] container rounded-xl flex justify-center items-center  ">
          <img
            src={img5}
            className="hover:scale-110 duration-1000 shadow-lg shadow-[#0f0f0f] object-cover w-full  rounded-md  object-center  md:h-[400px]"
            alt="Welcome Image"
            loading="lazy"
          />
        </div>
      </div>
      {/* <div  className=' grid md:grid-cols-2 bg-[#001ea1] gap-5 pt-7 py-5 px-5'>
                {/** Grid Item */}
      {/* <div className='   group container  flex justify-center items-center mx-auto '>
                    {/**Hover effect */}
      {/* <div className=''>   */}
      {/* <div className=' grid md:grid-cols-1 px-5 rounded-2xl shadow-2xl shadow-white py-5 bg-[#001ea1] text-2xl md:text-6xl items-center  justify-center text-center font-bold first-letter text-white tracking-wider'>
                             Join the club of choice in Ekurhuleni 
                             <div className='items-center py-6 rounded-md justify-center  md:pt-10 '>
                                    <a href="/MemberRegistration">
                                      <button className='text-center  shadow-2xl shadow-black text-[#001ea1] text-sm py-3   justify-center rounded-lg px-6 hover:font-bold  bg-white hover:scale-110 duration-500'> Join Us</button>
                                   </a>
                                </div>
                            </div> */}
      {/* </div>
                </div>   
                <div className=' shadow-[#0f0f0f] container rounded-xl flex justify-center items-center  '>
                        <img src={img105} className= ' shadow-2xl shadow-black container w-full  rounded-md  object-center  ' alt= 'Welcome Image' loading='lazy' />
                </div>        
        </div> */}
      {/* <div  className=' rounded-lg items-center flex justify-center relative ' >

                <img src={capture2 } className='h-full w-full absolute mix-blend-overlay object-cover' alt= 'Logo Image' loading='lazy'/>
                <div className='z-10'>
                          <a href="https://secure.onreg.com/onreg2/front/step1.php?id=6877">
                                  <button className='text-[#001ea1] font-bold rounded-lg  shadow-2xl shadow-black py-2 px-10 my-6 flex items-center bg-white hover:text-white hover:bg-[#001ea1] hover:scale-110 duration-500' >
                                 Register for our Human Rights Day Race <HiArrowNarrowRight className='ml-4'/></button>
                        </a>
                    </div>
 
          </div > */}
    </div>
  );
};

export default Home;
